import { NavLink } from "react-router-dom";
import { Gauge, ChatCircleDots, FileText, FilePlus, Microphone, Briefcase, GraduationCap, CurrencyDollar, Trophy, ShieldCheck, CreditCard, Gift, Headset } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: Gauge, testId: "side-dashboard" },
  { to: "/coach", label: "AI Coach", icon: ChatCircleDots, testId: "side-coach" },
  { to: "/resume", label: "Resume Review", icon: FileText, testId: "side-resume" },
  { to: "/resume-builder", label: "Resume Builder", icon: FilePlus, testId: "side-resume-builder" },
  { to: "/interview", label: "Interview Sim", icon: Microphone, testId: "side-interview" },
  { to: "/jobs", label: "Job Matches", icon: Briefcase, testId: "side-jobs" },
  { to: "/learning", label: "Learning", icon: GraduationCap, testId: "side-learning" },
  { to: "/salary", label: "Salary Tool", icon: CurrencyDollar, testId: "side-salary" },
  { to: "/profile", label: "Profile / XP", icon: Trophy, testId: "side-profile" },
  { to: "/referrals", label: "Invite & Earn", icon: Gift, testId: "side-referrals" },
  { to: "/pricing", label: "Upgrade", icon: CreditCard, testId: "side-pricing" },
  { to: "/contact", label: "Contact / Help", icon: Headset, testId: "side-contact" },
];

export const DashSidebar = () => {
  const { user } = useAuth();
  return (
    <aside className="hidden lg:flex w-60 shrink-0 flex-col gap-1 border-r border-white/10 bg-[#08080A] p-4 pt-24 fixed left-0 top-0 h-full" data-testid="dash-sidebar">
      <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-600 font-semibold px-3 mb-2">Workspace</div>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          data-testid={it.testId}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
              isActive ? "bg-blue-600/15 text-white border border-blue-500/30" : "text-zinc-400 hover:text-white hover:bg-white/5 border border-transparent"
            }`
          }
        >
          <it.icon size={18} weight="duotone" />
          {it.label}
        </NavLink>
      ))}
      {user?.is_admin && (
        <NavLink to="/admin" data-testid="side-admin"
          className={({ isActive }) =>
            `mt-2 flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
              isActive ? "bg-amber-600/15 text-white border border-amber-500/30" : "text-amber-400 hover:text-amber-300 hover:bg-amber-500/5 border border-transparent"
            }`
          }
        >
          <ShieldCheck size={18} weight="duotone" /> Admin Panel
        </NavLink>
      )}
    </aside>
  );
};
